export default [
    "Text",
    "Numeric",
    "Combo",
    "Date",
]